import React from 'react';
import cn from 'classnames';

import { UiKit } from 'components';
import styles from './index.module.scss';

/**
 * @param {Object} props
 * @param {string} props.title - The title of the feature.
 * @param {string} props.subtitle - The subtitle of the feature.
 * @param {import('utils/types').Space} [props.gap=40] - The gap between the header and the children.
 * @param {string} [props.className] - Additional class names for the container.
 * @param {React.ReactNode} props.children - The content of the feature.
 */
export default function FeatureContainer({
  title = '',
  subtitle = '',
  gap = 40,
  className = '',
  children = null
}) {
  return (
    <UiKit.Flex
      direction="column"
      gap={gap}
      className={cn(styles.container, className)}
    >
      <UiKit.Flex direction="column" gap={4}>
        <UiKit.Title>{title}</UiKit.Title>
        <UiKit.Text>{subtitle}</UiKit.Text>
      </UiKit.Flex>
      {children}
    </UiKit.Flex>
  );
}
